// extracted by mini-css-extract-plugin
export default {"Bounty":"Bounty_Bounty__WslFq","Button":"Bounty_Button__gggZS","Center":"Bounty_Center__cWLTY"};